var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header-tab-view"}},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:index,staticClass:"tab",on:{"click":function($event){return _vm.selectTab(tab)}}},[_c('i',{staticClass:"iconfont",class:tab.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(tab.name))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c966407","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/headerTabView/headerTabView.vue
// module id = null
// module chunks = 